
import { Spin } from "antd";
import { useCallback, useEffect, useState } from "react";
import CardDetailProject from "../../../components/Card/CardDetailProject";
import { TableGeneral } from "../../../components/table/TableGeneral";
import { FormUser } from "../../../components/Form/user/FormUser";
import { usePageUsersData } from "../../../hooks/controlPanel";
import { HeaderUser } from "./components/HeaderUser";

export const PageUser = () => {
    const [filteredProjects, setFilteredProjects] = useState([]);
    const [section, setSection] = useState(0);

    const {
        searchValue,
        activeModal,
        typeModal,
        loadingButton,
        isLoading,
        dataForm,
        handleOpenModalCreate,
        closeModal,
        onFinish,
        tableFilterDataUsers,
        handleChange,
        columns,
        countUser,
        tableData,
        rolUser,
        allAreas,
    } = usePageUsersData();


    const updateSelection = () => {
        setSection(0);
    }

    const change = useCallback((value) => {
        const isActive = value === 0
        setSection(isActive ? 0 : 1);
        setFilteredProjects(isActive ? tableData.filter(user => user.isActive) : tableData.filter(user => user.isActive === false))
    }, [tableData])


    useEffect(() => {
        change(section)
    }, [change, section, tableData])



    if (tableData.length === 0) {
        return (
            <div className="flex justify-center items-center w-full h-screen mx-auto">
                <Spin size="large" />
            </div>
        );
    }

    return (
        <div className="lg:p-12 p-4 w-full h-full flex flex-col gap-6">
            <CardDetailProject
                title="Usuarios"
                titleClass="order-first  md:w-[calc(100%-200px)]"
                headerChildren={
                    <HeaderUser
                        countUser={countUser}
                        handleChange={handleChange}
                        handleOpenModalCreate={handleOpenModalCreate}
                        onChangeSwitch={change}
                        searchValue={searchValue}
                        selectedSection={section}
                    />
                }
            >
                <div className="w-full">
                    <TableGeneral
                        column={columns}
                        state={filteredProjects}
                        loading={isLoading}
                        pagination={{
                            position: ["none", "none"],
                            pageSize: tableFilterDataUsers.length,
                        }}
                    />
                </div>

            </CardDetailProject>
            <FormUser
                activeModal={activeModal}
                allAreas={allAreas}
                closeModal={closeModal}
                isFormCreate={typeModal === 0}
                loading={loadingButton}
                onFinishForm={onFinish}
                rolUser={rolUser}
                dataForm={dataForm}
                updateSelection={updateSelection}
            />
        </div>
    );
};
